<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";

    const dispatch = createEventDispatcher();

    export let src = ''

    const volume = 1;

    let music: HTMLAudioElement;

    onMount(() => {
        music.volume = volume;
        music.play();
    });
</script>

<audio style="display: none;" src={src} preload="auto" bind:this={music} on:ended={() => dispatch('ended')} />
